import "./Footer.css";

import React from "react";

import weathersvlogo from "../images/weathersvlogo.png";

const Footer = ({ numActive, totalBroadcast }) => (
  <div id="footer">
    <div className="footer-row">
      <div className="footer-column">
        <p className="footer-heading">Powered By</p>
        <div>
          <a
            href="https://openweathermap.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            OpenWeatherMap
          </a>
        </div>
        <div>
          <a
            href="https://metastreme.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            MetaStreme
          </a>
        </div>
        <div>
          <a
            href="https://bitcoinsv.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            BitcoinSV
          </a>
        </div>
      </div>
      <div className="footer-column">
        <p className="footer-heading">About</p>
        <div>
          <a href="mailto:support@weathersv.com">Contact</a>
        </div>
        <div>
          <a
            href="https://www.opendatacommons.org/licenses/odbl/1.0/"
            target="_blank"
            rel="noopener noreferrer"
          >
            License
          </a>
        </div>
        <div>
          <a href="/docs" target="_blank" rel="noopener noreferrer">
            API
          </a>
        </div>
        <div>
          <a
            href="https://twitter.com/sv_weather"
            target="_blank"
            rel="noopener noreferrer"
          >
            Twitter
          </a>
        </div>
      </div>
      <div className="stats-column">
        <img className="footer-logo" src={weathersvlogo} alt="WeatherSV Logo" />
        <div>Active Channels: {numActive.toLocaleString()}</div>
        <div>Total Broadcasts: {totalBroadcast.toLocaleString()}</div>
        <p>Copyright © {new Date().getFullYear()} WeatherSV</p>
      </div>
    </div>
  </div>
);

export default Footer;
